import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Row,
    Image,
    Skeleton,
    Divider,
    Modal,
    Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import SingleImageUpload from "../../components/SingleImageUpload";
import notfound from "../../assets/images/not_found.png";

function Edit() {
    const navigate = useNavigate();
    const sectionName = "Setting";
    const routeName = "setting";
    const settingId = "65df3ae47ef7d58a02d3a945";

    const api = {
        edit: apiPath.updateSetting,
        get: apiPath.getSetting,
    };

    const [form] = Form.useForm();
    const [file, setFile] = useState([]);
    const [image, setImage] = useState();
    const FileType = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/gif"]

    const { request } = useRequest();
    const [loading, setLoading] = useState(false);

    const handleImage = (data) => {
        setImage(data);
        data.length > 0 ? setFile(data[0].url) : setFile();
    }

    const fetchData = () => {
        setLoading(true);
        request({
            url: api.get,
            method: "GET",
            onSuccess: (data) => {
                setLoading(false);
                setFile(data?.data?.splash_image);
                setImage(data?.data?.splash_image);
            },
            onError: (error) => {
                ShowToast(error, Severty.ERROR);
            },
        });
    };

    const onSubmit = (values) => {
        const payload = {};
        payload.splash_image = image && image.length > 0 ? image[0].url : '';
        request({
            url: api.edit,
            method: "POST",
            data: payload,
            onSuccess: (data) => {
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS);
                } else {
                    ShowToast(data.message, Severty.ERROR);
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR);
                setLoading(false);
            },
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Card title={"Update " + sectionName}>
                {loading ? (
                    [1, 2].map((item) => <Skeleton active key={item} />)
                ) : (
                    <Form
                        className="edit-page-wrap"
                        form={form}
                        onFinish={onSubmit}
                        autoComplete="off"
                        layout="vertical"
                        name="setting_form"
                    >
                        <Row gutter={[24, 0]}>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item className="mb-0"
                                    label={"Upload Image"}
                                    name="splash_image"
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                console.log(image, "image");
                                                if (image) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Image is required'));
                                            },
                                        }
                                    ]}>
                                    <SingleImageUpload value={image} fileType={FileType} imageType={'setting'} btnName={'Image'} onChange={(data) => handleImage(data)} />

                                </Form.Item>
                                {file && file.length > 0 && <div className="mt-2"> <Image width={120} src={file !== "" ? file : notfound}></Image> </div>}
                            </Col>
                        </Row>

                        <Form.Item className="btn-row float-right">
                            <Button type="primary" loading={loading} htmlType="submit">
                                Update Setting
                            </Button>
                        </Form.Item>
                    </Form>
                )}
            </Card>
        </>
    );
}

export default Edit;